module.exports = __webpack_public_path__ + "brandon_bld-webfont.7f6d4327268c85b578c5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_bld-webfont.woff2
// module id = 933
// module chunks = 7